export default __webpack_public_path__ + "static/media/Creative.8447ac5b.jpg";